(ns practitest.frontend.components2.dashboard.transforms.pie
  (:require [practitest.frontend.components2.dashboard.schema :as sc]
            [practitest.frontend.components2.dashboard.helpers :as h]))

(def desc >)

(defn- url-params [x-values-map {:keys [category grouped]}]
  {:x-param (when-not (= category h/empty-values)
              (get x-values-map (keyword category) (or grouped category)))})

(defn- prepare-data [{:chart/keys [data remove-empty-values x-values-map]}]
  (for [{:keys [category value] :as row} data
        :when (if remove-empty-values (pos? value) true)]
    {:category category :value value :url-params (url-params x-values-map row)}))

(defn transform
  {:malli/schema [:=> [:cat sc/PieChart]
                  sc/PieChartTransformed]}
  [chart]
  (-> chart
      prepare-data
      (as-> data
            (sort-by :value desc data)
            (assoc chart :chart/data (vec data)))))
